export default __webpack_public_path__ + "static/media/CodeBerry.da5e5d1a.svg";